import Notification from "../PureComponents/Notification";
import React from "react";

const RenderNotification = () => {
  return <Notification />;
};

export default RenderNotification;
